var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-layout',[_c('q-page-container',[_c('q-page',{attrs:{"padding":""}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }